import React from "react";
import ReactDOM from "react-dom";
import $ from "jquery";

import ModalFooter from "../../../intelws_portal/constructs/modal/ModalFooter";
import ModalHeader from "../../../intelws_portal/constructs/modal/ModalHeader";
import ModalDatePicker from "../../../intelws_portal/constructs/modal/ModalDatePicker";
import ModalInputText from "../../../intelws_portal/constructs/modal/ModalInputText";
import ModalCommetText from "../../../intelws_portal/constructs/modal/ModalCommentText";
import { getCancelToken, post } from "../../../intelws_portal/utils/backendInterface";
import { parseQueryResponseOnFail, parseQueryResponseOnSuccess } from "../../../declarations/common_utils";
import { AxiosResponse } from "axios";
import { IFollowUpEvents } from "../common/LeadTracking";

interface IPostLeadFollowUp extends AxiosResponse {
    data: {
        data: IFollowUpEvents
    }
}

export interface IModalLeadProps {
    leadId: number,
    saveCallback: (data?: IFollowUpEvents, success?: string[], fail?: string[]) => void,
    clearModal?: () => void
}

function ModalLead(props: IModalLeadProps) {
    const ENDPOINT = "/api/leads/";

    const [dueDate, setDueDate] = React.useState("");
    const [subject, setSubject] = React.useState("");
    const [description, setDescription] = React.useState("");
    const [disable, setDisable] = React.useState(true);

    const cancelTokenSource = React.useRef(getCancelToken());

    React.useEffect(() => {
        $("#leadDueDateModal").on("hidden.bs.modal", clearForm);
        return () => {
            $("#leadDueDateModal").off("hidden.bs.modal");
        }
    }, [])

    React.useEffect(() => {
        let newDisable = true;
        if (dueDate != "") {
            newDisable = false;
        }
        setDisable(newDisable);
    }, [dueDate]);

    function clearForm() {
        setDueDate("");
        setSubject("");
        setDescription("");
        props.clearModal?.();
    }

    function submitForm() {
        //props.saveCallback(dueDate);

        const queryParams = {
            section: "add_follow_up_lead"
        };

        const formData = new FormData();

        formData.append("lead_id", props.leadId.toString());
        formData.append("subject", subject);
        formData.append("description", description);
        formData.append("follow_up_date", dueDate);

        const requestResponse = post(ENDPOINT, formData, cancelTokenSource.current.token, queryParams) as Promise<IPostLeadFollowUp>;
        requestResponse.then((response) => {
            let [success, fail] = parseQueryResponseOnSuccess(response);
            props.saveCallback(response.data.data, success, fail);
        }).catch((error) => {
            let [success, fail] = parseQueryResponseOnFail(error);
            props.saveCallback(undefined, success, fail);
        })
        .finally(() => {
            $("#leadDueDateModal").modal("hide");
        })
    }
    
    function getModalContent() {
        return (
            <React.Fragment>
                <ModalHeader title="Lead Follow Up Date" />
                <div className="modal-body">
                    <ModalInputText title="Subject" value={subject} onChange={(e) => setSubject(e.target.value)} required />
                    <br />
                    <ModalCommetText title="Description" placeholder="Enter Follow Up Description Here" value={description} onChange={(e) => setDescription(e.target.value)} required />
                    <br />
                    <ModalDatePicker title="Follow Up Date" value={dueDate} onChange={(e) => setDueDate(e.target.value)} required/>
                </div>
                <ModalFooter saveCallback={submitForm} saveInactive={false} disable={disable}/>
            </React.Fragment>
        )
    }
    function relativeRender() {
        return <div className="modal fade custom-modal text-center" id="leadDueDateModal" tabIndex={-1}>
                <div className="modal-dialog text-left modal-lg">
                    <div className="modal-content">
                        {getModalContent()}
                    </div>
                </div>
            </div>
    }
    
    return ReactDOM.createPortal(relativeRender(), document.getElementById("modal") as Element);
}

export default ModalLead;